import React from "react";

export default function SearchAndSortBar({
  searchTerm,
  handleSearchChange,
  sortOption,
  handleSortChange,
  translations,
}) {
  return (
    <div className="flex items-center mb-4 w-full">
      <input
        type="text"
        placeholder={translations.course_search_placeholder}
        className="p-2 border rounded-md w-full mr-4"
        value={searchTerm}
        onChange={handleSearchChange}
      />
      <select
        className="p-2 border rounded-md w-auto mr-4"
        value={sortOption}
        onChange={handleSortChange}
      >
        <option value="فرز حسب">{translations.sort_by}</option>
        <option value="الأحدث">{translations.newest}</option>
        <option value="الأعلى تقييمًا">{translations.top_rated}</option>
      </select>
    </div>
  );
}
